import React from "react";

import { Localized } from "@fluent/react";
import PropTypes from "prop-types";

const DEFAULT_ELEMS = {
  strong: <strong />,
};

const FluentTranslate = ({ children, elems, ...props }) => React.createElement(
  Localized,
  {
    ...props,
    elems: { ...DEFAULT_ELEMS, ...elems },
  },
  props.children ?? React.createElement("span"),
);

FluentTranslate.propTypes = {
  vars: PropTypes.object,
  elems: PropTypes.object,
  props: PropTypes.any,
  children: PropTypes.node,
};

export default FluentTranslate;
